// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-visitor-reg {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
}

.form-card {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06);
}

.form-header {
  margin-bottom: 30px;
}

.form-header h1 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}

.form-header p {
  color: #64748b;
  font-size: 0.9rem;
}

.admin-reg-form .form-section {
  margin-bottom: 30px;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 20px;
}

.admin-reg-form .form-section:last-of-type {
  border-bottom: none;
}

.admin-reg-form .form-section h3 {
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #3b82f6;
  margin-bottom: 20px;
  font-weight: 700;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
}

.form-group input, .form-group select {
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.95rem;
  width: 100%;
}

.form-group input:focus, .form-group select:focus {
  border-color: #3b82f6;
  outline: none;
}

.field-error {
  color: #ef4444;
  font-size: 0.75rem;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}

/* Success Step */
.success-step {
  text-align: center;
  background: white;
  padding: 60px 40px;
  border-radius: 16px;
  box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1);
}

.success-header {
  margin-bottom: 40px;
}

.success-icon {
  width: 64px;
  height: 64px;
  background: #dcfce7;
  color: #166534;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  border-radius: 50%;
  margin: 0 auto 20px;
}

.qr-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-bottom: 40px;
  padding: 30px;
  background: #f8fafc;
  border-radius: 12px;
}

.visitor-summary {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.visitor-summary strong {
  font-size: 1.2rem;
  color: #0f172a;
}

.visitor-summary span {
  color: #64748b;
  font-size: 0.9rem;
}

.success-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/AdminVisitorRegistration.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2EAA2E;AAC7E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".admin-visitor-reg {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.form-card {\n  background: white;\n  padding: 40px;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06);\n}\n\n.form-header {\n  margin-bottom: 30px;\n}\n\n.form-header h1 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 4px;\n}\n\n.form-header p {\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.admin-reg-form .form-section {\n  margin-bottom: 30px;\n  border-bottom: 1px solid #f1f5f9;\n  padding-bottom: 20px;\n}\n\n.admin-reg-form .form-section:last-of-type {\n  border-bottom: none;\n}\n\n.admin-reg-form .form-section h3 {\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #3b82f6;\n  margin-bottom: 20px;\n  font-weight: 700;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #334155;\n}\n\n.form-group input, .form-group select {\n  padding: 10px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  width: 100%;\n}\n\n.form-group input:focus, .form-group select:focus {\n  border-color: #3b82f6;\n  outline: none;\n}\n\n.field-error {\n  color: #ef4444;\n  font-size: 0.75rem;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n/* Success Step */\n.success-step {\n  text-align: center;\n  background: white;\n  padding: 60px 40px;\n  border-radius: 16px;\n  box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1);\n}\n\n.success-header {\n  margin-bottom: 40px;\n}\n\n.success-icon {\n  width: 64px;\n  height: 64px;\n  background: #dcfce7;\n  color: #166534;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2rem;\n  border-radius: 50%;\n  margin: 0 auto 20px;\n}\n\n.qr-preview {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 40px;\n  padding: 30px;\n  background: #f8fafc;\n  border-radius: 12px;\n}\n\n.visitor-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.visitor-summary strong {\n  font-size: 1.2rem;\n  color: #0f172a;\n}\n\n.visitor-summary span {\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.success-actions {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n}\n\n@media (max-width: 768px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
